// Firebase configuration for Smart Sangola
// Replace the values below with your actual Firebase project config
// from https://console.firebase.google.com

import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';
import { getMessaging } from 'firebase/messaging';

// ⚠️  IMPORTANT: Replace with your Firebase WEB App project credentials
const firebaseConfig = {
  apiKey: "AIzaSyDov487bYERYwB9BuPL4qTPobs9nHK1qpo",
  authDomain: "smart-sangola.firebaseapp.com",
  projectId: "smart-sangola",
  storageBucket: "smart-sangola.firebasestorage.app",
  messagingSenderId: "563009331858",
  appId: "1:563009331858:web:bed7a5227dca22dae1bc4b"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);

// Messaging only works in supported browsers
let messaging = null;
try {
  messaging = getMessaging(app);
} catch (e) {
  console.warn('FCM not supported in this environment');
}
export { messaging };

export default app;
